import { LoadingComponent, useUrlParse } from '@amzn/event-engine-js-utils';
import {
    initialState as initialBreadcrumbsState,
    state as breadcrumbsState,
} from 'atoms/breadcrumbs';
import { state as disableContentPaddingsState } from 'atoms/disable-content-paddings';
import {
    initialState as initialToolState,
    state as toolsState,
} from 'atoms/tools';
import React, { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';

import LandingPage from './LandingPage';

interface LandingPageContainerProps {
    target?: HTMLElement | undefined;
}

const LandingPageContainer: React.FC<LandingPageContainerProps> = ({
    target,
}: LandingPageContainerProps) => {
    const setTools = useSetRecoilState(toolsState);
    const setBreadcrumbs = useSetRecoilState(breadcrumbsState);
    const setDisableContentPaddings = useSetRecoilState(
        disableContentPaddingsState
    );
    const { query } = useUrlParse(window.location.href);

    useEffect(() => {
        setBreadcrumbs(initialBreadcrumbsState);
        setTools(initialToolState);
        setDisableContentPaddings(true);

        return () => {
            setDisableContentPaddings(false);
        };
    }, []);

    if (query?.code && query?.state) {
        /**
         * if code and state are present, there is a redirect auth flow happening.
         * Instead of showing 404, show a loader while it redirects.
         */
        return <LoadingComponent containerProps={{ margin: 'm' }} />;
    }

    return <LandingPage target={target} />;
};

export default LandingPageContainer;
